module.exports = __webpack_public_path__ + "static/media/43.0f6022ab.png";